import { render, staticRenderFns } from "./ControlloAlloggiBarView.vue?vue&type=template&id=2e287654&"
import script from "./ControlloAlloggiBarView.vue?vue&type=script&lang=ts&"
export * from "./ControlloAlloggiBarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports